export default __webpack_public_path__ + "static/media/TitilliumWeb-Bold.6d6124d1.ttf";